import { render, staticRenderFns } from "./mp4-player.vue?vue&type=template&id=f371f2be&scoped=true&lang=pug"
import script from "./mp4-player.vue?vue&type=script&lang=coffee"
export * from "./mp4-player.vue?vue&type=script&lang=coffee"
import style0 from "./mp4-player.vue?vue&type=style&index=0&id=f371f2be&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f371f2be",
  null
  
)

export default component.exports